import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CallOutlined } from '@mui/icons-material';
import { updatePhoneNumber } from '../../service/operatori';
import { CircularProgress } from '@mui/material';
import { useSnackbar } from 'notistack';

const PhoneNumberDialog = ({

    idoperatorecantiere = "", 
    phonenumber = ""

} : {

    idoperatorecantiere: string, 
    phonenumber: string; 

}) => {

  const [open, setOpen] = React.useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = React.useState<string>(phonenumber); 
const [isLoading, setIsLoading] = React.useState<boolean>(false); 

const { enqueueSnackbar } = useSnackbar();


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onConfirm = async () => {

    setIsLoading(true); 

    try {

        await updatePhoneNumber(idoperatorecantiere, phoneNumber); 

        enqueueSnackbar("Numero di telefono aggiornato con successo", {
            variant: "success",
        });

        setOpen(false);

    } catch(e: any) {

        enqueueSnackbar(e.message ? e.message : e, {
            variant: "error",
        });

    } finally {

        setIsLoading(false); 

    }

  }

  return (
    <div>
      <Button onClick={handleClickOpen} variant="outlined" sx={{mb:2, ml: 2}} startIcon={<CallOutlined />}>Numero</Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Modifica numero di telefono</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Inserisci qui sotto il numero di telefono dell'operatore e premi il pulsante "conferma"
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="telefono"
            label="Numero di telefono"
            type="text"
            fullWidth
            value={phoneNumber}
            onChange={(evt) => setPhoneNumber(evt.target.value)}
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annulla</Button>
          <Button 
          disabled={isLoading === true ? true : false}
          onClick={onConfirm}>
            {isLoading === true ? ( <CircularProgress /> ) : "Conferma"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PhoneNumberDialog; 